import { COMPARISON_ROWS } from './constants.jsx';

export default function ComparisonTable() {
  return (
    <div className="max-w-4xl mx-auto mb-28 relative z-10">
      <div className="mb-8">
        <div className="ed-eyebrow mb-3">Vergleich</div>
        <h2 className="ed-display text-2xl md:text-4xl">Tresor gegen die Tech-Giganten.</h2>
      </div>
      <div className="overflow-x-auto w-full">
        <table className="ed-table min-w-[520px]">
          <thead>
            <tr>
              <th className="w-1/3">Merkmal</th>
              <th className="w-1/3 is-us">Datenputzer Tresor</th>
              <th className="w-1/3">Google Drive / Dropbox</th>
            </tr>
          </thead>
          <tbody>
            {COMPARISON_ROWS.map(([merkmal, us, them]) => (
              <tr key={merkmal}>
                <td className="font-medium">{merkmal}</td>
                <td className="font-medium">
                  <span className="inline-flex items-center gap-2">
                    <span className="ed-accent font-bold">✓</span>
                    {us}
                  </span>
                </td>
                <td className="ed-muted">{them}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
